<script setup lang="ts">import { ref as _ref } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { useRouter } from 'vue-router/composables';
import SButton from '@/components/SButton/SButton.vue';
import ConfirmationDialog from '@/components/confirmation-dialog/Confirmation-Dialog.vue';
import i18n from '@/i18n';
import type { Location } from 'vue-router';
import { VSelect } from 'vuetify/lib';
import { onMounted } from 'vue';

const router = useRouter();

const { value: selectedSearch } = __MACROS_useVModel(["value", undefined, "input"]);

const props = defineProps({
  items: null,
  value: null
});

const emit = defineEmits(["delete", "input"]);

const confirmationDialogRef = _ref<ConfirmationDialog | null>(null);
const select = _ref<InstanceType<typeof VSelect> | null>(null);

  const itemClickHandler = (item: { value: string, text: string, query: Location['query'] }) => {
  confirmationDialogRef.value!
    .setTitle(i18n.tc('save_search.delete_modal_title', 1, { count: 1 }) as string)
    .setBody(i18n.tc('save_search.delete_modal_description', 1, { count: 1 }) as string)
    .waitForUserAction()
    .then(() => {
      emit('delete', item.value);
    })
    .catch(() => { });
};

const handleInput = (value: string) => {
  if (value) {
    router.push({ query: props.items.find((item) => item.value === value)?.query });
  }
};

const handleClear = () => {
  router.push({ query: {} });
};

onMounted(() => {
  if (select.value?.$refs.input instanceof HTMLElement) {
    select.value.$refs.input.focus();
  }
});
</script>

<template lang="pug">
.save-search-selector

  ConfirmationDialog( ref="confirmationDialogRef" )

  v-select(
    ref="select"
    v-model="selectedSearch"
    :items="items"
    @input="handleInput"
    :menu-props="{ bottom: true, offsetY: true }"
    dense
    hide-details
    @click:clear="handleClear"
    outlined
    clearable)

    template( v-slot:item="{ item }")
      .d-flex.align-center.flex-grow-1.v-list-item--activator
        span.text-truncate.menu-item {{ item.text }}
        v-spacer
        SButton(
          class="show-on-hover-target"
          icon="icon-trash"
          size="x-small"
          color="danger"
          variant="text"
          @click="itemClickHandler(item)" )
</template>

<style lang="scss" scoped>
.menu-item {
  max-width: 240px;
}

:deep(.v-list-item) {
  & .show-on-hover-target {
    opacity: 0;
    visibility: hidden;
  }

  &:hover {
    .show-on-hover-target {
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
